
import React from 'react';
import { createPortal } from 'react-dom';

interface ConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    confirmText?: string;
    triggerRect: DOMRect | null;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ isOpen, onClose, onConfirm, title, message, confirmText = 'Confirm' }) => {
    if (!isOpen) return null;

    return createPortal(
        <div 
            className="fixed inset-0 bg-black/70 z-[9999] flex items-center justify-center p-4 animate-fade-in" 
            onClick={onClose}
            role="dialog"
            aria-modal="true"
            aria-labelledby="confirm-title"
        >
            <div 
                className="bg-[var(--primary-dark-purple)] border border-white/20 rounded-2xl shadow-2xl w-full max-w-sm flex flex-col animate-modal-pop-in overflow-hidden" 
                onClick={e => e.stopPropagation()}
            >
                {/* Header with Icon */}
                <div className="p-6 pb-2 text-center">
                    <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4 border border-red-500/30">
                        <i className="ph-duotone ph-warning-circle text-4xl text-red-400"></i>
                    </div>
                    <h2 id="confirm-title" className="text-xl font-bold text-white aurora-text">{title}</h2>
                </div>

                {/* Content */}
                <div className="px-6 py-2 text-center">
                    <p className="text-gray-300 text-sm leading-relaxed">{message}</p>
                </div>

                {/* Actions */}
                <div className="p-6 flex gap-3">
                    <button
                        onClick={onClose}
                        className="flex-1 bg-transparent border border-white/30 text-white font-bold py-3 px-4 rounded-xl hover:bg-white/10 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="flex-1 bg-gradient-to-r from-red-600 to-pink-600 text-white font-bold py-3 px-4 rounded-xl shadow-lg hover:opacity-90 transition-opacity"
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ConfirmationModal;
